import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
declare let L: any;
import 'leaflet.markercluster';
import 'leaflet-routing-machine';
import {fullScreenMap} from "../case-assign-vehicle/mapFullScreen";
import {ParameterService} from "../../services/parameter/parameter.service";
import {Option} from "../../../ui-components/core-dropdown/core-dropdown.component";
import {ApiService} from "../../services/api/api.service";
import {IVehicleLocation} from "./interfaces/vehicle-location.interface";
import {VehicleService} from "../../../pages/definition/vehicle/services/vehicle.service";
import {AppMessageService} from "../../services/app-message/app-message.service";
import {TranslateService} from "@ngx-translate/core";
import {formatDate} from "@angular/common";

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: '',
  iconUrl: '',
  shadowUrl: ''
});

interface Vehicle {
  id: string;
  plate: string;
  status: 'Müsait' | 'Hasta Taşınıyor' | 'Müdahale Ediyor';
  location: string;
  distance: string;
  latitude?: number;
  longitude?: number;
  marker?: L.CircleMarker;
}


@Component({
  selector: 'app-vehicle-location-map',
  templateUrl: './vehicle-location-map.component.html',
  styleUrl: './vehicle-location-map.component.scss',
})
export class VehicleLocationMapComponent implements OnInit, OnDestroy {

  @ViewChild('mapContainer') mapContainer?: ElementRef<HTMLElement>;

  @Input() vehicle: Vehicle;
  isVisible: boolean = false;
  searchTerm = '';
  isFullscreen = false;
  private map!: L.Map;
  @Input() selectedVehicle: number | null = null;
  @Input() type: 'case-timeline'|'organization-timeline'|null = null;
  selectedVehicleDot: any = null;
  activeType = 1;
  betweenTime: any  = null;
  betweenTimes: Option[] = [];
  vehicleOptions: any[] = [];
  filterCollaps: boolean = true;
  intervalLiveLocation: any;
  dotIcon: any;
  private polyline: L.Polyline;
  caseTimelineDatas:{
      startDate:Date,
      endDate:Date
  } | null;

  organizationTimelineDatas:{
      startDate:Date,
      endDate:Date
  } | null;

  locaitonIcon = L.icon({
    iconUrl: 'assets/markers/geo.gif',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -28]
  });

  loading:boolean=false

  constructor(private readonly parameterService: ParameterService, private readonly apiService: ApiService, private readonly vehicleService: VehicleService, private readonly appMessageService: AppMessageService, private readonly translate: TranslateService) {
  }

  ngOnInit(): void {
    this.parameterService
      .getValues('location-parameters', 'timeBetweens')
      .subscribe((response: any) => {
        this.betweenTimes = response.datas?.values.map((data: any) => ({
          label: data.valueObject.name.value,
          value: data.valueObject.timeBetween.value,
        }));
      });

    this.vehicleService.getVehicleList().subscribe((res) => {
      this.vehicleOptions = res?.map((item) => ({
        name: item?.licensePlate,
        value: Number(item.id),
      }));
    });
  }

  closeMap() {
    this.isVisible = false;
    this.selectedVehicle = null;
    this.destroyMap();
  }

  ngOnDestroy(): void {
    this.destroyMap();
  }

  private scheduleMapInit(delayMs = 300): void {
    setTimeout(() => {
      if (this.isVisible) {
        this.initMap();
      }
    }, delayMs);
  }

  private destroyMap(): void {
    if (this.intervalLiveLocation) {
      clearInterval(this.intervalLiveLocation);
      this.intervalLiveLocation = undefined;
    }
    if (this.map) {
      this.map.remove();
      this.map = undefined as unknown as L.Map;
    }
  }

  private initMap() {
    const container = this.mapContainer?.nativeElement;
    if (!container || !this.isVisible) {
      return;
    }
    if (this.map) {
      return;
    }

    this.map = L.map(container, {attributionControl: true}).setView(
      [41.0152, 28.5768],
      10
    );
    this.map.attributionControl.setPrefix('İDEA');

    let layers = {
      OSM: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 30,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }),


      CartoDB_Positron: L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 30
      }),

      Streets: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Hybrid: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Satellite: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Terrain: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
    };

    layers.CartoDB_Positron.addTo(this.map);
    L.control.layers(layers).addTo(this.map);

    fullScreenMap().addTo(this.map);
    this.polyline = L.polyline([], {color: 'blue'}).addTo(this.map);
  }

  open(args?:{caseStatusTimeline?:any,organizationParameters?:any}) {
    this.isVisible = true;

     //eğer case-timeline dan geliyor ise veriyi doldur
    if(args?.caseStatusTimeline){
        this.caseTimelineDatas={
          startDate:args?.caseStatusTimeline?.startDate,
          endDate:args?.caseStatusTimeline?.endDate,
        }
        setTimeout(() => {
          this.filter()
        }, 500);
     }

      if(args?.organizationParameters){
        this.organizationTimelineDatas={
          startDate:args?.organizationParameters?.startDate,
          endDate:args?.organizationParameters?.endDate,
        }
        setTimeout(() => {
          this.filter()
        }, 500);
     }
    this.scheduleMapInit();
  }


  filter() {
    this.loading=true;
    if (!this.map) {
      return;
    }

    // Interval varsa temizle
    if (this.intervalLiveLocation) {
      clearInterval(this.intervalLiveLocation);
    }

    // Mevcut marker ve polylineları kaldır
    this.map.eachLayer(layer => {
      if (layer instanceof L.Marker || layer instanceof L.Polyline) {
        this.map.removeLayer(layer);
      }
    });

    if (this.activeType === 1) {
      if ((this.betweenTime || this.caseTimelineDatas || this.organizationTimelineDatas) && this.selectedVehicle) {
        this.applyVehicleFilter();
      } else {
        this.appMessageService.warningToast(
          this.translate.instant('common.warning'),
          this.translate.instant('vehicle-control.empty-vehicleId-betweenTime')
        );
      }
    } else if (this.activeType === 2 && this.selectedVehicle) {
      this.liveLocationGet(13);
      this.getVehicleDetail();
      this.intervalLiveLocation = setInterval(() => this.liveLocationGet(), 10000);
    }
  }

  private applyVehicleFilter(): void {
    let filterObj: any = {
      'filter.vehicle_id': this.selectedVehicle,
      'filter.getAll': true,
    };

    // Case timeline
    if (this.caseTimelineDatas && this.type === 'case-timeline') {
      const { startDate, endDate } = this.caseTimelineDatas;
      if (!startDate || !endDate) return;
      filterObj['filter.created_at'] = `$btw:${new Date(formatDate(startDate, 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')).toISOString()},${new Date(formatDate(endDate, 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')).toISOString()}`;
    }

    // Organization timeline
    if (this.organizationTimelineDatas && this.type === 'organization-timeline') {
      const { startDate, endDate } = this.organizationTimelineDatas;
      if (!startDate || !endDate) return;
      filterObj['filter.created_at'] = `$btw:${new Date(formatDate(startDate, 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')).toISOString()},${new Date(formatDate(endDate, 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')).toISOString()}`;
    }

    // Between time
    if (this.betweenTime) {
      filterObj['filter.created_at'] = `$gte:${new Date(formatDate(new Date(Date.now() - this.betweenTime * 60 * 1000), 'yyyy-MM-ddTHH:mm:ss', 'tr-TR')).toISOString()}`;
    }

    this.loading = true;

    this.apiService.getFilter<IVehicleLocation[]>(`vehicle-tracking/vehicle-location-filter`, {
      event: { first: null, rows: null },
      filter: { ...filterObj }
    }).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.items.length > 0) {
          const coordinates: number[][] = res.items.map((loc:any) => [Number(loc.latitude), Number(loc.longitude)]);

          const startIcon = L.icon({
            iconUrl: 'assets/markers/start.png',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -28]
          });

          const endIcon = L.icon({
            iconUrl: 'assets/markers/end.png',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -28]
          });

          // Başlangıç ve bitiş markerları
          const first = coordinates[0] as [number, number];
          const last = coordinates.at(-1)! as [number, number];

          L.marker(first, { icon: endIcon })
            .addTo(this.map)
            .bindPopup(`${res.items[0].way}, ${res.items[0].quarter}`);

          L.marker(last, { icon: startIcon })
            .addTo(this.map)
            .bindPopup(`${res.items[coordinates.length - 1].way}, ${res.items[coordinates.length - 1].quarter}`);

          L.polyline(coordinates as [number, number][], { color: '#2694EF' }).addTo(this.map);
        }
      },
      error: (err) => {
        this.loading = false;
      }
    });

    this.getVehicleDetail();
  }


  liveLocationGet(zoom?: number) {
    this.map.eachLayer((layer) => {
      if (layer instanceof L.Marker || layer instanceof L.Polyline) {
        this.map.removeLayer(layer);
      }
    });
    this.apiService.get<IVehicleLocation[]>(`vehicle-tracking/vehicle-location-filter?filter.vehicle_id=${this.selectedVehicle}&limit=1&filter.live=1`).subscribe((res: any) => {
      this.loading=false;
      if (res.items.length > 0) {
        L.marker([Number(res.items[0]?.gpsData?.latitude), Number(res.items[0]?.gpsData?.longitude)], {icon: this.locaitonIcon})
          .addTo(this.map)
          .bindPopup(`${res.items[0]?.location?.way} ,${res.items[0]?.location?.quarter}`);
        if (zoom) {
          this.map.setView([Number(res.items[0]?.gpsData?.latitude), Number(res.items[0]?.gpsData?.longitude)], zoom);
        }
      }
    });
  }

  getVehicleDetail() {
    if (this.selectedVehicle && (this.type!=='case-timeline' && this.type!=='organization-timeline')) {
      this.dotIcon = L.icon({
        iconUrl: 'assets/markers/dot.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -28]
      });
      this.apiService.get(`vehicle/${this.selectedVehicle}`).subscribe((res: any) => {
        this.selectedVehicleDot = res?.dot;
        if (res?.dot?.address) {
          L.marker([Number(res?.dot?.address?.latitude), Number(res?.dot?.address?.longitude)], {icon: this.dotIcon})
            .addTo(this.map)
            .bindPopup(`${res?.dot?.address?.formattedAddress}`);
        }
      });
    }
  }


  toggleType(tabNumber: number): void {
    if (this.map) {
      this.map.eachLayer((layer) => {
        if (layer instanceof L.Marker || layer instanceof L.Polyline) {
          this.map.removeLayer(layer);
        }
      });
    }
    if (this.intervalLiveLocation) {
      clearInterval(this.intervalLiveLocation);
    }
    this.activeType = tabNumber;
    this.selectedVehicle = null;
    this.selectedVehicleDot = null;
  }

  openLiveLocationForVehicle(vehicleId: number) {
    this.activeType = 2;
    this.selectedVehicle = vehicleId;
    this.isVisible = true;
    this.filterCollaps = true;
    this.scheduleMapInit(300);
    setTimeout(() => {
      this.filter();
    }, 350);
  }

}
